import layoutStorage from './layoutStorage';

export default { layoutStorage };
